export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/bd.7b4951e0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};